/*
*
* File JS componente Block demo
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-demo.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockDemo = () => {

    window.triggerDemoChange = (evt) => {
        document.querySelector('.block-demo__cta').href = evt.target.value;
    }

}

export default blockDemo;

//--------------------------------------------------------------------//